import { ApiConfig } from '../../Config.js';
import axios from 'axios';

var GetTotalTransactionCtrl = function (fn, er, state, token, ids) {
	// var codPos = '';
	// if(sessionStorage.getItem("codepos") !== undefined && sessionStorage.getItem("codepos") !== ''){
	// 	codPos = sessionStorage.getItem("codepos");
	// } else {
	// 	codPos = sessionStorage.getItem("code") !== undefined && sessionStorage.getItem("code") !== '' ? sessionStorage.getItem("code") : ''
	// }
	
	var config = {
		headers: {
			'Authorization': 'Bearer ' + token,
			'Content-Type': 'application/json',
			'MT_SESSION_ID': ids
		},
	};
	var data = {
		day: state.selectedDay,
		maxAmount: state.maxamount,
		maxNetAmount: state.maxamountnet,
		minAmount: state.minamount,
		minNetAmount: state.minamountnet,
		month: state.selectedMonthYear,
		codPos: state.codepv,
		pos: state.codpos
	};

	console.log('DEBUG - Dati inviati al backend:', data);
	console.log('DEBUG - Token e headers:', {
		token: token ? 'presente' : 'mancante',
		ids: ids ? 'presente' : 'mancante'
	});

	axios
		.post(ApiConfig.url.GET_TOTAL_TRANSACTION, data, config)
		.then(function (result) {
			console.log(result)
			fn(result.data, result.status)
		})
		.catch(function (error) {
			er(error !== undefined && error.response !== undefined && error.response.status !== undefined ? error.response.status : 500)
		});
}

export { GetTotalTransactionCtrl };